module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "how-to-use-this-book"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("HOW TO USE THIS BOOK"), _c('a', {
    attrs: {
      "id": "how-to-use-this-book-anchor"
    }
  })])]), _c('a', {
    attrs: {
      "id": "how-to-use-this-book-anchor"
    }
  }, [_c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("By Carl Llewellyn Weschcke")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The book you hold in your hands is neither an ordinary book with its printed pages, nor a Traditionalist Book of Shadows. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Before I explain what the difference is and how to use this book, I want to tell you a few things relating to the author that may help your understanding.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The manuscript for this book had been “lost” among boxes of Scott Cunningham’s writings since his death in 1993. His original proposed title was “American Traditionalist Book of Shadows.” Due to events over the last quarter century, we felt that the word “Traditionalist” was no longer appropriate philosophically in association with the subject of Wicca.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Make no mistake, Scott Cunningham considered himself a Traditionalist in the original concept of that word: ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("A deep respect for tradition, especially for cultural or religious practice")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(". But our dictionary also offers an alternative definition: ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The idea that all knowledge comes from divine revelation and is passed on by tradition")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(". It is this latter definition that gives us some difficulty. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Wicca is not “revealed knowledge” stemming from a single source that becomes established as theologically sacrosanct, but is instead a living tradition that is personally experienced and integrated into ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("your")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" life.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Wicca does not have a fixed theology administered and taught by a “Council of Elders” similar to historic authoritarian religions. There are a number of Wiccan churches established to administer to the needs of their membership for such purposes as marriage, funerals, personal counseling, etc., and there are many small covens bringing people together, but most practitioners of Wicca are “solitaries” who see themselves not separated from others by belief and lifestyle but fully integrated into the larger community while finding their spiritual strength from within.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("It was mostly for these individuals that Scott wrote his books.")])]), _vm._v(" "), _c('p', {
    staticClass: "pause"
  }, [_c('img', {
    attrs: {
      "alt": "orn.eps",
      "src": "images/orn_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txnoi-sa"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("It’s important to our understanding of how to use a Book of Shadows to clearly separate Scott Cunningham’s writings from the anti-modernism and rigid fundamentalism characterized by that alternative definition of “Traditionalist.” It is also important to understand that Cunningham’s book is distinctly ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("American,")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" not Celtic or European.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Witchcraft is as old as the hills and is basically perceived as a system of nature-based magic and shamanism. Wicca is a modern nature-based religion that absorbed some practices and beliefs from traditional British Witchcraft. Yes, those beliefs and practices are mostly age-old, but they are also universal and readily adapted to the culture in which the practitioners are residents. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("It is in this sense of attunement with the ebb and flow of the natural environment, and in the sacredness of those energies and the very soil of the locality, that Wicca has its experiential roots—and not in some claimed revelation from “on high” and held sacrosanct, to be explained to the rest of us by theological authorities. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Scott Cunningham was an American, initiated into a California coven at an early age because of his interests and devotion to natural magic. He had many teachers and he was a persistent researcher, but mostly he learned through practice, meditation, self-study, and experimentation. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Scott wrote more than fifty books on many aspects of Wicca and nature magic during his too-short life (June 27, 1956–March 28, 1993). He had tremendous respect both for his primary subject, Wicca, and for his readers. Yes, he had a deep respect for cultural and religious tradition, but not for historic or religious authority. His authority came from his own research and experience. He was very concerned that nothing he wrote could result in harm to his readers and never provided a ritual, a recipe, or a formula that was not thoroughly tested by himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "pause"
  }, [_c('img', {
    attrs: {
      "alt": "orn.eps",
      "src": "images/orn_fmt1.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txnoi-sa"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("All of this is important to the subject of this essay on ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("How to Use This Book")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Traditionally, the student of Wicca interested in joining a coven was given that group’s Book of Shadows to copy in longhand. In every sense, that handwritten book was the particular group’s ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("sacred text")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(", containing basic rituals, celebrations and lore, the Laws, and the names and forms of the divine presence they integrated into their practices. These names and forms, the specific gods and goddesses, are among the most important secrets held by the group members. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("But, once copied, the Book of Shadows also became the student’s personal ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("grimoire")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(", a record book of his or her personal practices, meditations, realizations, experiments, and research. It is a ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("living")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" book, just like the life that Scott Cunningham lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("And this is the point of my little essay. Respect your Book of Shadows, honor Scott and those who have gone before, but never become rigid in your beliefs or practices, for Wicca is a living religion, life is ever changing, and the entire meaning and purpose of your life is to grow and become more than you are. All of us are in the process of ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("becoming")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" a whole person, integrating body, emotion, mind, and spirit. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("In our magical practices and celebrations we learn to inwardly tap into the collective wisdom (also called the collective unconscious) and bring into our personal consciousness the knowledge we need to grow.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("In this book you will find the ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Thirteen Goals of a Witch")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(":")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I. Know yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" II. Know the Craft")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" III. Learn")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" IV. Apply your learning")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" V. Achieve balance")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" VI. Resist temptations")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" VII. Keep your thoughts in good order")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" VIII. Celebrate life")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" IX. Attune with the cycles of the universe")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" X. Breathe and eat correctly")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" XI. Exercise both mind and body")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" XII. Meditate")])]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" XIII. Honor and worship Diana and Kernunnos")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The only one of these goals that I believe needs a little explanation is the thirteenth. Diana and Kernunnos are indeed the names of a goddess and a god, and knowing their names and their form is the key to their worship, but they have also become abstractions and are not the universal aspects of divinity worshipped by all Wiccans. The gods and the goddesses have many names and many forms, and each group or each solitary practitioner must find their own. Deep inside you will find your god and your goddess, and you will know their names and forms. ")])]), _vm._v(" "), _c('p', {
    staticClass: "pause"
  }, [_c('img', {
    attrs: {
      "alt": "orn.eps",
      "src": "images/orn_fmt2.jpeg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "txnoi"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("This Book of Shadows is your book and your grimoire and can be adapted for group use or for solitary use. It is ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("your")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" sacred book.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("How to use this book")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("? Study ")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" practice. If you are a solitary, begin by living in the cycles of the Sun and the Moon, i.e., by the seasonal celebrations (Sabbats) and the lunar phases of Full and New Moon (Esbats). Even alone, you can assume the roles of priest and priestess, and learn to experience the essence of those energies that are the")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(" tides of life")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(". A time will come when you will know the presence of both the masculine and feminine forces we know as God and Goddess, whose divinity lives within our body, our feeling, our mind, and our spirit, and who live everywhere. You can speak to them inwardly and outwardly. You can see them in your heart and in your space. You can feel them and know them. And in your spirit you can be with them. If you prefer, you can perceive and receive their divine presence as singular rather than dual. We can’t define the “Creator” in any way other than to know the divine is everywhere at all times, and is the Source of all that is. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Don’t worry about doing everything exactly as it is in the book. See the book as a guide, not a rule book. You are the center of your universe, and your feet are planted in a particular place unique in space and time that will shape your experience. It is through this experience that you will grow and become more than you are—ever evolving—and become a whole person, able to handle the powers that will come to you through growth and development.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Crowley said that every man and woman is a star, and")]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(" so wilt thou be")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "pause"
  }, [_c('img', {
    attrs: {
      "alt": "orn.eps",
      "src": "images/orn_fmt3.jpeg"
    }
  })])]), _c('p', {
    staticClass: "contents"
  }, [_c('a', {
    attrs: {
      "id": "how-to-use-this-book-anchor"
    }
  }, [_c('span', {
    staticClass: "generated-style"
  })]), _c('a', {
    attrs: {
      "href": "#/Contents#x-contents-anchor"
    }
  }, [_vm._v("[contents]")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-285ae022","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/How_to_Use_This_Book.vue
// module id = 75
// module chunks = 0